import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PatientService from "../services/PatientService";
import VisitService from "../services/VisitService";
import AuthService from "../services/AuthService";
import moment from "moment";
 

const styles = {
    pageWrapper: { padding: "20px", backgroundColor: "#f4f7f6", minHeight: "100vh", fontFamily: "'Segoe UI', sans-serif" },
    headerSection: { backgroundColor: "#fff", padding: "25px", borderRadius: "12px", marginBottom: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" },
    nameTitle: { margin: 0, color: "#333", fontSize: "28px", fontWeight: "700" },
    patientMeta: { display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "15px", paddingBottom: "15px", borderBottom: "1px solid #eee" },
    metaItem: { background: "#f8f9fa", padding: "6px 12px", borderRadius: "8px", fontSize: "13px", color: "#555", border: "1px solid #e9ecef" },
    medicalGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "15px", marginTop: "20px" },
medicalBox: { padding: "15px", borderRadius: "10px", border: "1px solid #eee", fontSize: "14px", cursor: "pointer", transition: "0.2s", height: "100px", overflow: "hidden", display: "flex", flexDirection: "column" },    labelStyle: { fontWeight: "bold", fontSize: "11px", textTransform: "uppercase", display: "block", marginBottom: "5px", color: "#888" },
    tableCard: { background: "#fff", padding: "20px", borderRadius: "12px", marginBottom: "25px", boxShadow: "0 2px 10px rgba(0,0,0,0.05)", overflowX: "auto" },
    mainTable: { width: "100%", borderCollapse: "collapse" },
    thRow: { textAlign: "left", borderBottom: "2px solid #eee", color: "#888", fontSize: "12px", padding: "12px 8px" },
    todayRow: { background: "#f0f7ff", borderBottom: "2px solid #007bff" },
    historyRow: { borderBottom: "1px solid #eee", fontSize: "14px", color: "#444" },
    tdStyle: { padding: "12px 8px" },
    editableTd: { padding: "8px", cursor: "pointer", borderBottom: "1px dashed #ccc", display: "inline-block", minWidth: "40px", textAlign: "center" },
    tableInput: { width: "90%", padding: "8px", border: "1px solid #ddd", borderRadius: "6px", fontSize: "14px", backgroundColor: "#fff" },
    tableTitle: { fontSize: "18px", borderLeft: "5px solid #007bff", paddingLeft: "15px", marginBottom: "20px", color: "#222", fontWeight: "600" },
    saveAllBtn: { background: "#28a745", color: "#fff", border: "none", padding: "15px 40px", borderRadius: "30px", cursor: "pointer", fontWeight: "bold", fontSize: "16px", boxShadow: "0 4px 12px rgba(40, 167, 69, 0.3)", transition: "0.3s" },
    dietGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "20px", marginTop: "20px" },
    dietCard: { backgroundColor: "#fff", padding: "20px", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", borderTop: "4px solid #007bff", position: "relative", },
    dietDate: { fontSize: "14px", fontWeight: "bold", color: "#555", marginBottom: "10px", display: "block" },
    dietWeight: { fontSize: "18px", fontWeight: "bold", color: "#28a745", marginBottom: "10px" },
    dietPlanText: { fontSize: "14px", color: "#444", lineHeight: "1.5", backgroundColor: "#f9f9f9", padding: "10px", borderRadius: "8px", whiteSpace: "pre-wrap" ,cursor: "pointer",
    border: "1px solid #eee",overflowY: "hidden",maxHeight: "100px",},
    deleteBtn: { background: "none", border: "none", color: "#e53e3e", cursor: "pointer", fontSize: "16px", padding: "5px" },
    editInput: { width: "100%", border: "1px solid #007bff", borderRadius: "4px", padding: "4px" },
    addBtnCircle: { 
    backgroundColor: "#176d8a", color: "white", border: "none", borderRadius: "50%", 
    width: "35px", height: "35px", fontSize: "22px", cursor: "pointer", 
    display: "flex", alignItems: "center", justifyContent: "center", transition: "0.2s" 
}
};

const PatientCarton = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [patient, setPatient] = useState(null);
    const [loading, setLoading] = useState(true);
    const [history, setHistory] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const [editField, setEditField] = useState(null);
    const [editHistoryCell, setEditHistoryCell] = useState(null);
const [showHistory, setShowHistory] = useState(false);
const [hideEmpty, setHideEmpty] = useState(true); // Po defaultu sakrivamo prazne
    const initialTodayData = {
        weight: "", height: "", bodyFat: "", protein: "", visceralFat: "", 
        waist: "", hip: "", chest: "", abdomen: "", notes: "", dietPlan: ""
    };
    const [todayData, setTodayData] = useState(initialTodayData);
    // Kontroliše da li je panel za novi unos otvoren
const [showAddManual, setShowAddManual] = useState(false);
// Čuva datum koji izabereš (default je danas)
const [manualDate, setManualDate] = useState(new Date().toISOString().split('T')[0]);
    const todayVisitFromHistory = useMemo(() => {
        const todayStr = new Date().toLocaleDateString("sr-RS");
        return history.find(v => new Date(v.visitDate).toLocaleDateString("sr-RS") === todayStr);
    }, [history]);

    const isAlreadySavedToday = !!todayVisitFromHistory;

    const getTreatmentDetails = (visit) => {
        return visit?.visitItemDTOS?.find(i => 
            Number(i.treatmentTypeDTO?.treatmentTypeID) === 3 || 
            i.treatmentTypeDTO?.typeName?.toLowerCase() === "auriculotherapy"
        )?.treatmentTypeDTO;
    };

    const todayDetails = getTreatmentDetails(todayVisitFromHistory);

    const loadAllData = useCallback(async (user) => {
        if (!user) return;
        try {
            setLoading(true);
            const [patientData, allVisits] = await Promise.all([
                PatientService.getPatientById(id),
                VisitService.getAllVisitsByPatientId(id)
            ]);
            setPatient(patientData);
            const filtered = (allVisits || []).filter(v => 
                v.visitItemDTOS?.some(item => 
                    Number(item.treatmentTypeDTO?.treatmentTypeID) === 3 || 
                    item.treatmentTypeDTO?.typeName?.toLowerCase() === "auriculotherapy"
                )
            ).sort((a, b) => new Date(b.visitDate) - new Date(a.visitDate));
            setHistory(filtered);
        } catch (err) {
            console.error("Greška:", err);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if (!user) navigate("/login");
        else { setCurrentUser(user); loadAllData(user); }
    }, [navigate, loadAllData]);

    const handleUpdateMedicalInfo = async (field, value) => {
        if (patient[field] === value) { setEditField(null); return; }
        try {
            const updatedPatient = { ...patient, [field]: value };
            await PatientService.update(id, updatedPatient);
            setPatient(updatedPatient);
        } catch (err) {
            alert("Greška pri čuvanju.");
        } finally { setEditField(null); }
    };

    const handleUpdateVisitItem = async (visit, field, value) => {
        try {
            const itemIndex = visit.visitItemDTOS.findIndex(i => 
                Number(i.treatmentTypeDTO?.treatmentTypeID) === 3 || 
                i.treatmentTypeDTO?.typeName?.toLowerCase() === "auriculotherapy"
            );
            if (itemIndex === -1) return;
            const updatedVisit = JSON.parse(JSON.stringify(visit));
            const numericFields = ['weight', 'height', 'bodyFat', 'protein', 'visceralFat', 'waist', 'hipCircumference', 'chestCircumference', 'abdomenCircumference'];
            
            updatedVisit.visitItemDTOS[itemIndex].treatmentTypeDTO[field] = 
                numericFields.includes(field) ? (value === "" ? null : Number(value)) : value;

            await VisitService.updateVisit(visit.visitID, updatedVisit);
            setHistory(prev => prev.map(v => v.visitID === visit.visitID ? updatedVisit : v));
        } catch (err) {
            console.error("Greška pri ažuriranju:", err);
        } finally { setEditHistoryCell(null); }
    };

    const handleDeleteVisit = async (visitId) => {
        if (window.confirm("Da li ste sigurni da želite da obrišete ovaj pregled?")) {
            try {
                await VisitService.deleteVisit(visitId);
                setHistory(prev => prev.filter(v => v.visitID !== visitId));
            } catch (err) {
                alert("Greška pri brisanju: " + err.message);
            }
        }
    };
    const handleUpdateVisitDate = async (visit, newDate) => {
    try {
        const updatedVisit = { 
            ...visit, 
            status: "DONE",
visitDate: moment(newDate).format("YYYY-MM-DDTHH:mm:ss")        };
        await VisitService.updateVisit(visit.visitID, updatedVisit);
        // Osvežavamo listu da bi se redosled (sortiranje) ažurirao ako treba
        loadAllData(currentUser); 
    } catch (err) {
        console.error("Greška pri promeni datuma:", err);
        alert("Nije uspela promena datuma.");
    }
};
const handleSaveManualVisit = async () => {
    if (!todayData.weight) { 
        alert("Molimo unesite kilažu pre čuvanja."); 
        return; 
    }
    try {
        const visitDTO = {
            visitDate: new Date(manualDate).toISOString(),
            doctorDTO: { doctorID: currentUser?.doctorId || 1 },
            patientDTO: { patientID: Number(id) },
            visitItemDTOS: [{
                treatmentTypeDTO: {
                    typeName: "Auriculotherapy",
                    weight: Number(todayData.weight),
                    dietPlan: todayData.dietPlan,
                    // Ostali atributi se ne šalju, pa će u bazi biti null
                }
            }]
        };
        await VisitService.createVisit(visitDTO);
        alert("Poseta uspešno dodata!");
        
        // Resetuj polja i zatvori panel
        setTodayData(initialTodayData);
        setShowAddManual(false);
        // Osveži istoriju da se pojavi nova kartica
        loadAllData(currentUser);
    } catch (err) {
        alert("Greška pri čuvanju: " + err.message);
    }
};

    const saveTodayVisit = async (selectedDate = null) => {
    // 1. Provera (ako je današnji datum, proveri da li je već sačuvano)
    if (!selectedDate && isAlreadySavedToday) return;
    
    if (!todayData.weight) { 
        alert("Unesite težinu pre čuvanja."); 
        return; 
    }

    try {
        const finalDate = selectedDate 
            ? moment(selectedDate).format("YYYY-MM-DDTHH:mm:ss") 
            : moment().format("YYYY-MM-DDTHH:mm:ss");

        const visitDTO = {
            visitDate: finalDate,
            status: "DONE",
            doctorDTO: { doctorID: currentUser?.doctorId || 1 },
            patientDTO: { patientID: Number(id) },
            visitItemDTOS: [{
                treatmentTypeDTO: {
                    typeName: "Auriculotherapy",
                    weight: todayData.weight === "" ? null : Number(todayData.weight),
                    height: todayData.height === "" ? null : Number(todayData.height),
                    bodyFat: todayData.bodyFat === "" ? null : Number(todayData.bodyFat),
                    protein: todayData.protein === "" ? null : Number(todayData.protein),
                    visceralFat: todayData.visceralFat === "" ? null : Number(todayData.visceralFat),
                    waist: todayData.waist === "" ? null : Number(todayData.waist),
                    hipCircumference: todayData.hip === "" ? null : Number(todayData.hip),
                    chestCircumference: todayData.chest === "" ? null : Number(todayData.chest),
                    abdomenCircumference: todayData.abdomen === "" ? null : Number(todayData.abdomen),
                    dietPlan: todayData.dietPlan,
                    notes: todayData.notes
                }
            }]
        };

        await VisitService.createVisit(visitDTO);
        alert("Uspešno sačuvano!");
        
        // Resetovanja
        setTodayData(initialTodayData);
        setShowAddManual(false); // Zatvori panel ako je bio otvoren
        setManualDate("");       // Resetuj datum
        loadAllData(currentUser);
    } catch (err) {
        alert("Greška: " + err.message);
    }
};

    const EditableCell = ({ visit, field, value, type = "number" }) => {
        const isEditing = editHistoryCell?.visitId === visit.visitID && editHistoryCell?.field === field;
        if (isEditing) {
            return (
                <input autoFocus style={{width: "80%", padding: "4px"}} type={type} defaultValue={value}
                    onBlur={(e) => handleUpdateVisitItem(visit, field, e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleUpdateVisitItem(visit, field, e.target.value)}
                />
            );
        }
        return <span onClick={() => setEditHistoryCell({ visitId: visit.visitID, field })} style={styles.editableTd}>{value ?? "-"}</span>;
    };

    if (loading) return <div style={{textAlign: "center", padding: "50px"}}>Učitavanje...</div>;

    return (
        <div style={styles.pageWrapper}>
            <div style={styles.headerSection}>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <h1 style={styles.nameTitle}>{patient.name} {patient.surname}</h1>
                    <div style={{display: "flex", gap: "10px"}}>
                        <button onClick={() => navigate(`/patient-progress/${id}`)} style={{ border: "none", padding: "8px 15px", borderRadius: "6px", cursor: "pointer", background: "#007bff", color: "white", fontWeight: "bold" }}>Grafikoni 📊</button>
                        <button onClick={() => navigate(-1)} style={{border: "none", padding: "8px 15px", borderRadius: "6px", cursor: "pointer", background: "#6c757d", color: "white"}}>Zatvori</button>
                    </div>
                </div>
                <div style={styles.patientMeta}>
                    <div style={styles.metaItem}>📅 {patient.birthDate?.slice(0, 10)}</div>
                    <div style={styles.metaItem}>📞 {patient.phone}</div>
                    <div style={styles.metaItem}>🆔 LBO: {patient.lbo}</div>
                </div>

               <div style={styles.medicalGrid}>
    {/* ALERGIJE */}
    <div style={{...styles.medicalBox, backgroundColor: "#fff5f5", borderColor: "#feb2b2", ...(editField === 'allergies' ? {height: "auto", minHeight: "100px"} : {})}} onClick={() => setEditField('allergies')}>
        <span style={styles.labelStyle}>Alergije ⚠️</span>
        {editField === 'allergies' ? (
            <textarea autoFocus style={{...styles.editInput, width: "100%", height: "80px", resize: "none"}} defaultValue={patient.allergies} onBlur={(e) => { handleUpdateMedicalInfo('allergies', e.target.value); setEditField(null); }} />
        ) : (
            <p style={{margin: 0, fontWeight: "bold", wordBreak: "break-word"}}>{patient.allergies || "Nema"}</p>
        )}
    </div>

    {/* OPERACIJE */}
    <div style={{...styles.medicalBox, backgroundColor: "#fdf8e3", borderColor: "#faebcc", ...(editField === 'surgeries' ? {height: "auto", minHeight: "100px"} : {})}} onClick={() => setEditField('surgeries')}>
        <span style={styles.labelStyle}>Operacije</span>
        {editField === 'surgeries' ? (
            <textarea autoFocus style={{...styles.editInput, width: "100%", height: "80px", resize: "none"}} defaultValue={patient.surgeries} onBlur={(e) => { handleUpdateMedicalInfo('surgeries', e.target.value); setEditField(null); }} />
        ) : (
            <p style={{margin: 0, wordBreak: "break-word"}}>{patient.surgeries || "/"}</p>
        )}
    </div>

    {/* HRONIČNO */}
    <div style={{...styles.medicalBox, backgroundColor: "#f0fff4", borderColor: "#c6f6d5", ...(editField === 'otherInfo' ? {height: "auto", minHeight: "100px"} : {})}} onClick={() => setEditField('otherInfo')}>
        <span style={{...styles.labelStyle, color: "#2f855a"}}>Drugo / Hronično</span>
        {editField === 'otherInfo' ? (
            <textarea autoFocus style={{...styles.editInput, width: "100%", height: "80px", resize: "none"}} defaultValue={patient.otherInfo} onBlur={(e) => { handleUpdateMedicalInfo('otherInfo', e.target.value); setEditField(null); }} />
        ) : (
            <p style={{margin: 0, wordBreak: "break-word"}}>{patient.otherInfo || "/"}</p>
        )}
    </div>

    {/* NAPOMENA */}
    <div style={{...styles.medicalBox, backgroundColor: "#f0f7ff", borderColor: "#d0e3ff", ...(editField === 'medicalNote' ? {height: "auto", minHeight: "100px"} : {})}} onClick={() => setEditField('medicalNote')}>
        <span style={styles.labelStyle}>Napomena</span>
        {editField === 'medicalNote' ? (
            <textarea autoFocus style={{...styles.editInput, width: "100%", height: "80px", resize: "none"}} defaultValue={patient.medicalNote} onBlur={(e) => { handleUpdateMedicalInfo('medicalNote', e.target.value); setEditField(null); }} />
        ) : (
            <p style={{margin: 0, wordBreak: "break-word"}}>{patient.medicalNote || "/"}</p>
        )}
    </div>
</div>
            </div>

         <div style={styles.tableCard}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
        <h3 
            style={{ ...styles.tableTitle, cursor: "pointer", margin: 0 }} 
            onClick={() => setShowHistory(!showHistory)}
        >
            Sastav tela i Analize {showHistory ? "▲" : "▼"}
        </h3>
        
        {showHistory && (
            <button 
                onClick={() => setHideEmpty(!hideEmpty)}
                style={{ fontSize: "12px", padding: "4px 10px", borderRadius: "10px", border: "1px solid #ccc", cursor: "pointer" }}
            >
                {hideEmpty ? "Prikaži sve prazne" : "Sakrij prazne unose"}
            </button>
        )}
    </div>

    <table style={styles.mainTable}>
        <thead>
            <tr style={styles.thRow}>
                <th>Datum</th><th>Visina (cm)</th><th>Masti %</th><th>Mišići %</th><th>Visc.</th><th>Beleška</th><th>Akcija</th>
            </tr>
        </thead>
        <tbody>
            {/* --- DANAŠNJI RED (UVEK VIDLJIV) --- */}
            <tr style={styles.todayRow}>
                <td style={styles.tdStyle}>
    <input 
        type="date"
        style={{...styles.tableInput, fontWeight: "bold", border: "none", background: "transparent"}}
        value={isAlreadySavedToday 
            ? moment(todayVisitFromHistory.visitDate).format("YYYY-MM-DD") 
            : moment().format("YYYY-MM-DD")
        }
        onChange={(e) => isAlreadySavedToday && handleUpdateVisitDate(todayVisitFromHistory, e.target.value)}
    />
</td>
                <td><input style={styles.tableInput} type="number" value={isAlreadySavedToday ? (todayDetails?.height || "") : todayData.height} onChange={e => isAlreadySavedToday ? handleUpdateVisitItem(todayVisitFromHistory, "height", e.target.value) : setTodayData({...todayData, height: e.target.value})}/> </td>
                <td><input style={styles.tableInput} type="number" value={isAlreadySavedToday ? (todayDetails?.bodyFat || "") : todayData.bodyFat} onChange={e => isAlreadySavedToday ? handleUpdateVisitItem(todayVisitFromHistory, "bodyFat", e.target.value) : setTodayData({...todayData, bodyFat: e.target.value})} /></td>
                <td><input style={styles.tableInput} type="number" value={isAlreadySavedToday ? (todayDetails?.protein || "") : todayData.protein} onChange={e => isAlreadySavedToday ? handleUpdateVisitItem(todayVisitFromHistory, "protein", e.target.value) : setTodayData({...todayData, protein: e.target.value})} /></td>
                <td><input style={styles.tableInput} type="number" value={isAlreadySavedToday ? (todayDetails?.visceralFat || "") : todayData.visceralFat} onChange={e => isAlreadySavedToday ? handleUpdateVisitItem(todayVisitFromHistory, "visceralFat", e.target.value) : setTodayData({...todayData, visceralFat: e.target.value})} /></td>
                <td><input style={styles.tableInput} type="text" value={isAlreadySavedToday ? (todayDetails?.notes || "") : todayData.notes} onChange={e => isAlreadySavedToday ? handleUpdateVisitItem(todayVisitFromHistory, "notes", e.target.value) : setTodayData({...todayData, notes: e.target.value})} /></td>
                <td style={styles.tdStyle}>
                    {isAlreadySavedToday ? (
                        <button onClick={() => handleDeleteVisit(todayVisitFromHistory.visitID)} style={styles.deleteBtn}>🗑️</button>
                    ) : "-"}
                </td>
            </tr>

            {/* --- ISTORIJA PREGLEDA (VIDLJIVA SAMO NA KLIK) --- */}
            {showHistory && history
                .filter(v => {
    // Provera da li je danas koristeći moment (sigurnije poređenje bez zone)
    const isToday = moment(v.visitDate).isSame(moment(), 'day');
    
    if (isToday) return false; 

    if (hideEmpty) {
        const d = getTreatmentDetails(v);
        return d.height || d.bodyFat || d.protein || d.visceralFat || (d.notes && d.notes.trim() !== "");
    }
    return true;
})
                .map(v => {
    const d = getTreatmentDetails(v);
    return (
        <tr key={v.visitID} style={styles.historyRow}>
            <td style={styles.tdStyle}>
                <input 
                    type="date"
                    style={{...styles.tableInput, border: "none", background: "transparent", fontSize: "14px"}}
                    // IZMENA: Moment garantovano izvlači datum bez pomeranja unazad
                    value={moment(v.visitDate).format("YYYY-MM-DD")}
                    onChange={(e) => handleUpdateVisitDate(v, e.target.value)}
                />
            </td>
                            <td style={styles.tdStyle}><EditableCell visit={v} field="height" value={d.height} /></td>
                            <td style={styles.tdStyle}><EditableCell visit={v} field="bodyFat" value={d.bodyFat} /></td>
                            <td style={styles.tdStyle}><EditableCell visit={v} field="protein" value={d.protein} /></td>
                            <td style={styles.tdStyle}><EditableCell visit={v} field="visceralFat" value={d.visceralFat} /></td>
                            <td style={styles.tdStyle}><EditableCell visit={v} field="notes" value={d.notes} type="text" /></td>
                            <td style={styles.tdStyle}>
                                <button onClick={() => handleDeleteVisit(v.visitID)} style={styles.deleteBtn}>🗑️</button>
                            </td>
                        </tr>
                    );
                })
            }
        </tbody>
    </table>
</div>

            <div style={styles.tableCard}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
        {/* Naslov koji kontroliše otvaranje istorije obima */}
        <h3 
            style={{ ...styles.tableTitle, cursor: "pointer", margin: 0 }} 
            onClick={() => setShowHistory(!showHistory)}
        >
            Obimi tela (cm) {showHistory ? "▲" : "▼"}
        </h3>

        {showHistory && (
            <button 
                onClick={() => setHideEmpty(!hideEmpty)}
                style={{ fontSize: "11px", padding: "4px 10px", borderRadius: "10px", border: "1px solid #ccc", cursor: "pointer", background: hideEmpty ? "#f0f7ff" : "#fff" }}
            >
                {hideEmpty ? "Prikaži sve prazne" : "Sakrij prazne unose"}
            </button>
        )}
    </div>

    <table style={styles.mainTable}>
        <thead>
            <tr style={styles.thRow}>
                <th>Datum</th>
                <th>Grudi</th>
                <th>Struk</th>
                <th>Stomak</th>
                <th>Kukovi</th>
                <th>Akcija</th>
            </tr>
        </thead>
        <tbody>
            {/* --- DANAŠNJI RED (UVEK VIDLJIV) --- */}
            <tr style={styles.todayRow}>
    <td style={styles.tdStyle}>
        <input 
            type="date"
            style={{...styles.tableInput, fontWeight: "bold", border: "none", background: "transparent"}}
            value={isAlreadySavedToday 
                ? moment(todayVisitFromHistory.visitDate).format("YYYY-MM-DD") 
                : moment().format("YYYY-MM-DD")
            }
            onChange={(e) => isAlreadySavedToday && handleUpdateVisitDate(todayVisitFromHistory, e.target.value)}
        />
    </td>

    <td>
                    <input 
                        style={styles.tableInput} 
                        type="number" 
                        value={isAlreadySavedToday ? (todayDetails?.chestCircumference || "") : todayData.chest} 
                        onChange={e => isAlreadySavedToday 
                            ? handleUpdateVisitItem(todayVisitFromHistory, "chestCircumference", e.target.value) 
                            : setTodayData({...todayData, chest: e.target.value})} 
                    />
                </td>
                <td>
                    <input 
                        style={styles.tableInput} 
                        type="number" 
                        value={isAlreadySavedToday ? (todayDetails?.waist || "") : todayData.waist} 
                        onChange={e => isAlreadySavedToday 
                            ? handleUpdateVisitItem(todayVisitFromHistory, "waist", e.target.value) 
                            : setTodayData({...todayData, waist: e.target.value})} 
                    />
                </td>
                <td>
                    <input 
                        style={styles.tableInput} 
                        type="number" 
                        value={isAlreadySavedToday ? (todayDetails?.abdomenCircumference || "") : todayData.abdomen} 
                        onChange={e => isAlreadySavedToday 
                            ? handleUpdateVisitItem(todayVisitFromHistory, "abdomenCircumference", e.target.value) 
                            : setTodayData({...todayData, abdomen: e.target.value})} 
                    />
                </td>
                <td>
                    <input 
                        style={styles.tableInput} 
                        type="number" 
                        value={isAlreadySavedToday ? (todayDetails?.hipCircumference || "") : todayData.hip} 
                        onChange={e => isAlreadySavedToday 
                            ? handleUpdateVisitItem(todayVisitFromHistory, "hipCircumference", e.target.value) 
                            : setTodayData({...todayData, hip: e.target.value})} 
                    />
                </td>
                
                <td style={styles.tdStyle}>
                    {isAlreadySavedToday ? (
                        <button onClick={() => handleDeleteVisit(todayVisitFromHistory.visitID)} style={styles.deleteBtn}>🗑️</button>
                    ) : "-"}
                </td>
            </tr>

            {/* --- ISTORIJA OBIMA (VIDLJIVA NA KLIK) --- */}
            {showHistory && history
                .filter(v => {
                    const isToday = new Date(v.visitDate).toLocaleDateString("sr-RS") === new Date().toLocaleDateString("sr-RS");
                    if (isToday) return false;

                    if (hideEmpty) {
                        const item = v.visitItemDTOS?.find(i => Number(i.treatmentTypeDTO?.treatmentTypeID) === 3 || i.treatmentTypeDTO?.typeName?.toLowerCase() === "auriculotherapy");
                        const d = item?.treatmentTypeDTO;
                        // Provera da li bar jedan obim postoji
                        return d && (d.waist || d.abdomenCircumference || d.hipCircumference || d.chestCircumference);
                    }
                    return true;
                })
                .map(v => {
                    const item = v.visitItemDTOS?.find(i => Number(i.treatmentTypeDTO?.treatmentTypeID) === 3 || i.treatmentTypeDTO?.typeName?.toLowerCase() === "auriculotherapy");
                    const d = item?.treatmentTypeDTO;
                    if (!d && !hideEmpty === false) return null; 

                    return (
                        <tr key={v.visitID} style={styles.historyRow}>
                            <td style={styles.tdStyle}>
                                <input 
                                    type="date"
                                    style={{...styles.tableInput, border: "none", background: "transparent", fontSize: "14px"}}
value={moment(v.visitDate).format("YYYY-MM-DD")}
                                    onChange={(e) => handleUpdateVisitDate(v, e.target.value)}
                                />
                            </td>
                            <td style={styles.tdStyle}><EditableCell visit={v} field="chestCircumference" value={d?.chestCircumference} /></td>
                            <td style={styles.tdStyle}><EditableCell visit={v} field="waist" value={d?.waist} /></td>
                            <td style={styles.tdStyle}><EditableCell visit={v} field="abdomenCircumference" value={d?.abdomenCircumference} /></td>
                            <td style={styles.tdStyle}><EditableCell visit={v} field="hipCircumference" value={d?.hipCircumference} /></td>
                            <td style={styles.tdStyle}>
                                <button onClick={() => handleDeleteVisit(v.visitID)} style={styles.deleteBtn}>🗑️</button>
                            </td>
                        </tr>
                    );
                })
            }
        </tbody>
    </table>
</div>


      {/* Naslov sa Plus dugmetom desno */}
<div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px"}}>
    <h3 style={{...styles.tableTitle, marginBottom: 0}}>Istorija Jelovnika i Kilaže</h3>
    <button onClick={() => setShowAddManual(!showAddManual)} style={styles.addBtnCircle}>
        {showAddManual ? "×" : "+"}
    </button>
</div>

{/* Panel koji se otvara na klik plusa */}
{showAddManual && (
    <div style={{ ...styles.tableCard, backgroundColor: "#f0f7ff", border: "1px solid #176d8a", marginBottom: "20px", padding: "15px" }}>
        {/* Promenjeno u flex-start da bi labela bile u ravni */}
        <div style={{ display: "flex", gap: "15px", flexWrap: "wrap", alignItems: "flex-start" }}>
            
            {/* KOLONA ZA DATUM */}
            <div style={{ flex: 1, minWidth: "160px" }}>
                <label style={styles.labelStyle}>Datum</label>
                <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                    <input 
                        type="text" 
                        style={{ ...styles.tableInput, paddingRight: "40px", cursor: "default" }} 
                        value={manualDate ? moment(manualDate).format("DD/MM/YYYY") : ""}
                        readOnly 
                    />
                    <input 
                        type="date" 
                        value={manualDate}
                        onChange={(e) => setManualDate(e.target.value)}
                        style={{
                            position: "absolute",
                            right: "5px",
                            width: "30px",
                            height: "100%",
                            opacity: 0,
                            cursor: "pointer",
                            zIndex: 2
                        }}
                    />
                    <span style={{ position: "absolute", right: "10px", fontSize: "18px", zIndex: 1 }}>📅</span>
                </div>
            </div>

            {/* KOLONA ZA KILAŽU */}
            <div style={{ flex: "0 1 90px" }}>
                <label style={styles.labelStyle}>Kilaža</label>
                <input 
                    type="number" 
                    style={styles.tableInput} 
                    value={todayData.weight} 
                    onChange={e => setTodayData({...todayData, weight: e.target.value})} 
                    placeholder="0.0" 
                />
            </div>

            {/* KOLONA ZA JELOVNIK */}
            <div style={{ flex: 4, minWidth: "300px" }}>
                <label style={styles.labelStyle}>Plan Ishrane (Jelovnik)</label>
                <textarea 
                    style={{ 
                        ...styles.tableInput, 
                        height: "120px", 
                        resize: "vertical", 
                        padding: "10px",
                        lineHeight: "1.4",
                        display: "block" // Osigurava da se ponaša kao block unutar flex-a
                    }} 
                    value={todayData.dietPlan} 
                    onChange={e => setTodayData({...todayData, dietPlan: e.target.value})} 
                    placeholder="Unesite detaljan jelovnik..." 
                />
            </div>

            {/* DUGME - Centrirano u odnosu na visinu panela ili fiksirano gore */}
            <div style={{ flex: "0 1 auto", alignSelf: "flex-start", marginTop: "24px" }}>
                <button 
                    onClick={() => saveTodayVisit(manualDate)} 
                    style={{ ...styles.saveAllBtn, padding: "10px 20px", fontSize: "14px", margin: 0 }}
                >
                    Dodaj
                </button>
            </div>

        </div>
    </div>
)}
            <div style={styles.dietGrid}>
                {history.map(v => {
                    const item = v.visitItemDTOS?.find(i => Number(i.treatmentTypeDTO?.treatmentTypeID) === 3 || i.treatmentTypeDTO?.typeName?.toLowerCase() === "auriculotherapy");
                    const d = item?.treatmentTypeDTO;
                    if (!d) return null;
                    return (
                        <div key={v.visitID} style={styles.dietCard}>
                            <button onClick={() => handleDeleteVisit(v.visitID)} style={{position: "absolute", top: "10px", right: "10px", background: "none", border: "none", cursor: "pointer", fontSize: "12px"}}>❌</button>
                            <span style={styles.dietDate}>📅 {new Date(v.visitDate).toLocaleDateString("sr-RS")}</span>
                            <div style={styles.dietWeight}>⚖️ <EditableCell visit={v} field="weight" value={d.weight} /> kg</div>
                            <div style={styles.labelStyle}>Plan Ishrane:</div>
                            <div style={styles.dietPlanText} onClick={() => setEditHistoryCell({ visitId: v.visitID, field: "dietPlan" })}>
                                {editHistoryCell?.visitId === v.visitID && editHistoryCell?.field === "dietPlan" ? (
                                    <textarea autoFocus style={styles.editInput} defaultValue={d.dietPlan} onBlur={(e) => handleUpdateVisitItem(v, "dietPlan", e.target.value)} />
                                ) : (d.dietPlan || "Nema definisanog jelovnika.")}
                            </div>
                        </div>
                    );
                })}
            </div>

           <div style={{textAlign: "center", padding: "40px 0"}}>
    <button 
        onClick={() => saveTodayVisit()} // Bez parametara = današnji datum
        disabled={isAlreadySavedToday}
        style={isAlreadySavedToday ? {...styles.saveAllBtn, ...styles.disabledBtn} : styles.saveAllBtn}
    >
        {isAlreadySavedToday ? "✅ Sačuvano" : "💾 Sačuvaj današnji pregled"}
    </button>
</div>
        </div>
    );
};

export default PatientCarton;